import { Pipe, PipeTransform } from '@angular/core';
import {Product} from '../types/models';
import {ProductService} from '../services/customer/product.service';

// brand and amount of a product like the search list shows them, e.g. "Haribo · 175 g" (delivery views: pieces also in total)
@Pipe({
  name: 'productSlimText'
})
export class ProductSlimTextPipe implements PipeTransform {

  constructor(private productService: ProductService) {
  }

  transform(product: Product): string {
    return this.productService.getSlimText(product, true);
  }

}
